import React from 'react'
import styled from 'styled-components'
import FacebookIcon from '../Icons/FacebookIcon'
import InstaIcon from '../Icons/InstaIcon'
import LinkedInIcon from '../Icons/LinkedInIcon'
import { device } from '../../../utils/helpers'

const Wrapper = styled.ul`
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: center;

  @media ${device.tablet} {
    display: flex;
    padding-bottom: 2em;
  }
`

const ListItem = styled.li`
  padding: 0 1.4rem;

  @media ${device.tablet} {
    padding: 0 1rem;
  }

  @media ${device.desktop} {
    padding: 0 1.4rem;
  }
`

const StyledLink = styled.a`
  text-decoration: none;

  &:hover {
    color: ${props => props.theme.color.hoverPrimary};
  }
`

const Facebook = styled(FacebookIcon)`
  width: 17px;

  @media ${device.tablet} {
    width: 0.8854166666666667vw;
  }

`

const Insta = styled(InstaIcon)`
  width: 40px;

  @media ${device.tablet} {
    width: 2.0833333333333335vw;
  }
`

const LinkedIn = styled(LinkedInIcon)`
  width: 40px;

  @media ${device.tablet} {
    width: 2.34375VW;
  }
`

const IconItem = ({ children, to, ...props }) => (
  <ListItem>
    <StyledLink href={to} {...props}>
      {children}
    </StyledLink>
  </ListItem>
)

const IconNav = ({ items }) => (
  <Wrapper>
    <IconItem to='https://www.facebook.com/noleggiocampi/' target='_blank'>
      <Facebook fill='#4d4d4d' />
    </IconItem>
    <IconItem to='https://www.instagram.com/noleggiocampi.it/' target='_blank'>
      <Insta fill='#4d4d4d' />
    </IconItem>
    <IconItem to='https://www.linkedin.com/company/noleggiocampi-it/' target='_blank'>
      <LinkedIn fill='#4d4d4d' />
    </IconItem>
  </Wrapper>
)

export default IconNav



// WEBPACK FOOTER //
// ./src/components/UI/Footer/IconNav.js